module.exports = __webpack_public_path__ + "img/feature-work-4-large.6d06b478.jpg";